// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav_nav_section__0aXem {
  position: relative;
  max-width: 100vw;
  padding: 1.6rem 4rem 1.6rem 6rem;
  margin: 0;
  border-bottom: 1px solid var(--text-color);
  background: none;

  & img {
    width: 100%;
    height: auto;
  }
}

.nav_link_section__2uQta {
  display: flex;
  justify-content: center;
  gap: 30px;

  & a {
    color: var(--text-color);
    font-family: Inter;
    font-size: 0.8rem;
    font-weight: 400;
    text-decoration: none;
  }
}

.nav_link_section2__GY\\+q5{
  padding-top: 12px !important;
}

/* --------submenu-------- */

/* .submenu {
  width: 50%;
  z-index: 2;
  position: absolute;
  top: 100%;
  left: 330px;
  background-color: var(--text-color);
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  padding: 1.2rem;
  display: flex;
  gap: 2rem; 
} */

.nav_nav_item__1YhrZ {
  position: relative;
}

.nav_sec__tIJWD {
  border: none;
  width: 600px;
  background-color: var(--text-color);
  margin-top: 18px;
  display: flex;
  gap: 40px;
}

.nav_nav_item__1YhrZ > .nav_submenu__\\+\\+J2L {
  width: auto;
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  background-color: transparent;
  padding: 1rem 0;
  z-index: 10;

  & h6 {
    padding: 3px 0;
    cursor: pointer;
    color: #000;
    font-family: Inter;
    font-size: 0.8rem;
    font-weight: 700;
  }

  & a {
    position: relative;
    display: block;
    color: var(--secondary-color) !important;
    font-family: Inter;
    font-size: 0.87rem;
    padding: 0.2rem !important;
    font-weight: 300 !important;
    text-decoration: none;
  }
}

.nav_nav_item__1YhrZ:hover > .nav_submenu__\\+\\+J2L {
  display: flex;
  justify-content: flex-start;
  gap: 5rem;
}

.nav_submenuChild__put6L {
  width: 40%;
  padding: 1.2rem;
  display: flex;
  flex-direction: column;
}

.nav_another_child__Ut1HQ {
  display: flex;
  padding: 1.2rem;
  flex-direction: column;
}

.nav_submenu__\\+\\+J2L a:hover {
  font-weight: 300 !important;
  text-decoration: underline;
  transition: transform 0.4s ease-in;
}

.nav_submenu__\\+\\+J2L a svg {
  display: none;
  transition: transform 0.2s ease-out;
}

.nav_submenu__\\+\\+J2L a:hover svg {
  display: inline;
  position: absolute;
  right: 0;
  /* margin-left: 1rem; */
  font-weight: 300 !important;
  transform: translateX(5px); /* Optional: Adds a sliding effect */
}

/* ------------submenu-end---------- */

.nav_btn__Dwfgq button {
  display: flex;
  width: 107px;
  padding: 10px;
  gap: 10px;
  border-radius: 4px;
  color: #fff;
  border: none;
  font-family: Inter;
  font-size: 0.87rem;
  font-weight: 500;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.23);
}

.nav_mobile_responsive__yYHWy {
  display: none;
}

.nav_responsive_menu__t6315 {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #fafafa;
  padding: 20px;
  border: 1px solid #d9d9d9;
  box-shadow: 0 4px 5px rgb(41 35 35 / 10%);
}

.nav_responsive_menu__t6315 a {
  margin-bottom: 10px;
  text-decoration: none;
  color: #333;
  font-family: inter;
  font-weight: 600;
}

.nav_responsive_btn__T2CZH button {
  display: flex;
  width: 107px;
  padding: 10px;
  gap: 10px;
  border-radius: 4px;
  color: var(--seconday-color);
  font-family: Inter;
  font-size: 0.87rem;
  font-weight: 500;
  align-items: center;
  justify-content: center;
  border: 1px solid #d0d0d0;
  background: rgba(255, 255, 255, 0.23);
}

/* ---------media-queris--------- */

@media screen and (max-width: 768px) {
  .nav_mobile_responsive__yYHWy {
    display: flex;
    position: relative;
    justify-content: space-between;
    margin: 0;
    padding: 1rem;

    .nav_logo__c7Qc\\+ {
      width: 80%;
    }

    & img {
      width: 70%;
      height: auto;
    }
  }

  .nav_submenu__\\+\\+J2L {
    margin-bottom: 0.6rem;
    padding: 9px;
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 100%;
    height: auto;
    /* position: absolute; */
    top: 12%;
    gap: 1rem;
    left: 200px;
    background-color: var(--text-color);
    box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.1);

    .nav_submenuChild__put6L {
      width: 100%;
    }

    & a {
      display: block;
      margin: 0;
      padding: 2px 0;
    }

    & h6 {
      margin: 0;
    }
  }

  .nav_nav_section__0aXem {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Navbar/nav.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,SAAS;EACT,0CAA0C;EAC1C,gBAAgB;;EAEhB;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;;EAET;IACE,wBAAwB;IACxB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;EACvB;AACF;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,4BAA4B;;AAE5B;;;;;;;;;;;GAWG;;AAEH;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mCAAmC;EACnC,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,6BAA6B;EAC7B,eAAe;EACf,WAAW;;EAEX;IACE,cAAc;IACd,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,wCAAwC;IACxC,kBAAkB;IAClB,kBAAkB;IAClB,0BAA0B;IAC1B,2BAA2B;IAC3B,qBAAqB;EACvB;AACF;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,UAAU;EACV,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,uBAAuB;EACvB,2BAA2B;EAC3B,0BAA0B,EAAE,oCAAoC;AAClE;;AAEA,sCAAsC;;AAEtC;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;EACb,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA,mCAAmC;;AAEnC;EACE;IACE,aAAa;IACb,kBAAkB;IAClB,8BAA8B;IAC9B,SAAS;IACT,aAAa;;IAEb;MACE,UAAU;IACZ;;IAEA;MACE,UAAU;MACV,YAAY;IACd;EACF;;EAEA;IACE,qBAAqB;IACrB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,mCAAmC;IACnC,0CAA0C;;IAE1C;MACE,WAAW;IACb;;IAEA;MACE,cAAc;MACd,SAAS;MACT,cAAc;IAChB;;IAEA;MACE,SAAS;IACX;EACF;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".nav_section {\n  position: relative;\n  max-width: 100vw;\n  padding: 1.6rem 4rem 1.6rem 6rem;\n  margin: 0;\n  border-bottom: 1px solid var(--text-color);\n  background: none;\n\n  & img {\n    width: 100%;\n    height: auto;\n  }\n}\n\n.link_section {\n  display: flex;\n  justify-content: center;\n  gap: 30px;\n\n  & a {\n    color: var(--text-color);\n    font-family: Inter;\n    font-size: 0.8rem;\n    font-weight: 400;\n    text-decoration: none;\n  }\n}\n\n.link_section2{\n  padding-top: 12px !important;\n}\n\n/* --------submenu-------- */\n\n/* .submenu {\n  width: 50%;\n  z-index: 2;\n  position: absolute;\n  top: 100%;\n  left: 330px;\n  background-color: var(--text-color);\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n  padding: 1.2rem;\n  display: flex;\n  gap: 2rem; \n} */\n\n.nav_item {\n  position: relative;\n}\n\n.sec {\n  border: none;\n  width: 600px;\n  background-color: var(--text-color);\n  margin-top: 18px;\n  display: flex;\n  gap: 40px;\n}\n\n.nav_item > .submenu {\n  width: auto;\n  display: none;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  background-color: transparent;\n  padding: 1rem 0;\n  z-index: 10;\n\n  & h6 {\n    padding: 3px 0;\n    cursor: pointer;\n    color: #000;\n    font-family: Inter;\n    font-size: 0.8rem;\n    font-weight: 700;\n  }\n\n  & a {\n    position: relative;\n    display: block;\n    color: var(--secondary-color) !important;\n    font-family: Inter;\n    font-size: 0.87rem;\n    padding: 0.2rem !important;\n    font-weight: 300 !important;\n    text-decoration: none;\n  }\n}\n\n.nav_item:hover > .submenu {\n  display: flex;\n  justify-content: flex-start;\n  gap: 5rem;\n}\n\n.submenuChild {\n  width: 40%;\n  padding: 1.2rem;\n  display: flex;\n  flex-direction: column;\n}\n\n.another_child {\n  display: flex;\n  padding: 1.2rem;\n  flex-direction: column;\n}\n\n.submenu a:hover {\n  font-weight: 300 !important;\n  text-decoration: underline;\n  transition: transform 0.4s ease-in;\n}\n\n.submenu a svg {\n  display: none;\n  transition: transform 0.2s ease-out;\n}\n\n.submenu a:hover svg {\n  display: inline;\n  position: absolute;\n  right: 0;\n  /* margin-left: 1rem; */\n  font-weight: 300 !important;\n  transform: translateX(5px); /* Optional: Adds a sliding effect */\n}\n\n/* ------------submenu-end---------- */\n\n.btn button {\n  display: flex;\n  width: 107px;\n  padding: 10px;\n  gap: 10px;\n  border-radius: 4px;\n  color: #fff;\n  border: none;\n  font-family: Inter;\n  font-size: 0.87rem;\n  font-weight: 500;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.23);\n}\n\n.mobile_responsive {\n  display: none;\n}\n\n.responsive_menu {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  background-color: #fafafa;\n  padding: 20px;\n  border: 1px solid #d9d9d9;\n  box-shadow: 0 4px 5px rgb(41 35 35 / 10%);\n}\n\n.responsive_menu a {\n  margin-bottom: 10px;\n  text-decoration: none;\n  color: #333;\n  font-family: inter;\n  font-weight: 600;\n}\n\n.responsive_btn button {\n  display: flex;\n  width: 107px;\n  padding: 10px;\n  gap: 10px;\n  border-radius: 4px;\n  color: var(--seconday-color);\n  font-family: Inter;\n  font-size: 0.87rem;\n  font-weight: 500;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #d0d0d0;\n  background: rgba(255, 255, 255, 0.23);\n}\n\n/* ---------media-queris--------- */\n\n@media screen and (max-width: 768px) {\n  .mobile_responsive {\n    display: flex;\n    position: relative;\n    justify-content: space-between;\n    margin: 0;\n    padding: 1rem;\n\n    .logo {\n      width: 80%;\n    }\n\n    & img {\n      width: 70%;\n      height: auto;\n    }\n  }\n\n  .submenu {\n    margin-bottom: 0.6rem;\n    padding: 9px;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    width: 100%;\n    height: auto;\n    /* position: absolute; */\n    top: 12%;\n    gap: 1rem;\n    left: 200px;\n    background-color: var(--text-color);\n    box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.1);\n\n    .submenuChild {\n      width: 100%;\n    }\n\n    & a {\n      display: block;\n      margin: 0;\n      padding: 2px 0;\n    }\n\n    & h6 {\n      margin: 0;\n    }\n  }\n\n  .nav_section {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nav_section": `nav_nav_section__0aXem`,
	"link_section": `nav_link_section__2uQta`,
	"link_section2": `nav_link_section2__GY+q5`,
	"nav_item": `nav_nav_item__1YhrZ`,
	"sec": `nav_sec__tIJWD`,
	"submenu": `nav_submenu__++J2L`,
	"submenuChild": `nav_submenuChild__put6L`,
	"another_child": `nav_another_child__Ut1HQ`,
	"btn": `nav_btn__Dwfgq`,
	"mobile_responsive": `nav_mobile_responsive__yYHWy`,
	"responsive_menu": `nav_responsive_menu__t6315`,
	"responsive_btn": `nav_responsive_btn__T2CZH`,
	"logo": `nav_logo__c7Qc+`
};
export default ___CSS_LOADER_EXPORT___;
